import { Component, EventEmitter, Output } from '@angular/core';
/* eslint @nrwl/nx/enforce-module-boundaries: 0 */
import { DataAccessTogglesFacade } from '@planone/shared/data-access-feature-flags';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'bau365-shell-mobile-layer-header',
  templateUrl: './mobile-layer-header.component.html',
  styleUrls: ['./mobile-layer-header.component.scss'],
})
export class MobileLayerHeaderComponent {
  @Output()
  closeMenu: EventEmitter<void> = new EventEmitter<void>();

  newsfeedEnabled$: Observable<boolean | undefined>;

  constructor(feature: DataAccessTogglesFacade) {
    this.newsfeedEnabled$ = feature.flag('kill-newsfeed').pipe(map((newsfeedDisabled) => !newsfeedDisabled));
  }

  onClickClose() {
    this.closeMenu.emit();
  }
}
